import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ArenaAuthProvider } from "./context/ArenaAuthContext";
import { ContributorAuthProvider } from "./context/ContributorAuthContext";
import { InstituteAuthProvider } from "./context/InstituteAuthContext";
import { BusinessAuthProvider } from "./context/BusinessAuthContext";
import "@fortawesome/fontawesome-free/css/all.css";
import { ToastContainer } from "react-toastify";

import Search from "./Informatica/search";
import RegisterContributor from "./Informatica/registerContributor";
import AdminPanel from "./Admin/Informatica/adminPanel";
import ContributorLogin from "./Informatica/loginContributor";
import ContributorDashboard from "./Informatica/contributor-dashboard/contributordashboard";
import EditContributorProfile from "./Informatica/contributor-dashboard/EditContributorProfile";
import ArticlePost from "./Informatica/contributor-dashboard/ArticlePost";
import EditArticle from "./Informatica/contributor-dashboard/EditArticle";
import ArticleAdminPanel from "./Admin/Informatica/ArticleAdminPanel";
import SearchResults from "./Informatica/SearchResults";
import ViewArticle from "./Informatica/ViewArticle";
import Dashboard from "./dasboard-component/MainDashboard";
import ManageUser from "./dasboard-component/ManageUser";
import TransactionHistory from "./dasboard-component/TransactionHistory";
import VerificationPage from "./Authentication/verificationPage";
import Signup from "./Authentication/signup";
import ForgotPassword from "./Authentication/ForgotPassword";

import ArenaUserDashboard from "./ArenaManagementSystem/arena_user_dashboard/Main_user_dash";
import RegisterArena from "./ArenaManagementSystem/arena-reg/regarena";
import ArenaDashboard from "./ArenaManagementSystem/arena-dashboard/arenaDashboard";
import LoginArena from "./ArenaManagementSystem/arena-reg/arenalogin";
import ForgotPasswordArena from "./ArenaManagementSystem/arena-reg/ForgotPasswordArena";
import ArenaAdminDashboard from "./Admin/Arena/AdminDashboard";
import LoginUser from "./Authentication/loginUser";
import ArenaDetails from "./ArenaManagementSystem/arena_user_dashboard/ArenaDetails";
import DsportAdminDashboard from "./Admin/DsportsAdminDashboard";
import InstituteDashboard from "./institutes/instituteDashboard/InstituteDashboard";
import InstituteLogin from "./institutes/instituteLogin/InstituteLogin";
import ForgotPasswordInstitute from "./institutes/instituteLogin/ForgotPasswordInstitute";
import InstituteOwnerDashboard from "./institutes/instituteOwnerDashboard/InstituteOwnerDashboard";
import InstituteGameSelection from "./institutes/instituteOwnerDashboard/InstituteGameSelection";
import InstituteViewGame from "./institutes/instituteOwnerDashboard/InstituteViewGame";
import InstituteProfileManagement from "./institutes/instituteProfile/InstituteProfileManagement";
import UserAffiliationsDashboard from "./institutes/userAffiliations/UserAffiliationsDashboard";
import ArenaOwnershipTransfer from "./ArenaManagementSystem/arena-dashboard/ArenaOwnershipTransfer";
import AssetDashboard from "./AssetManagement/AssetDashboard";

// slog
// import Home from "../src/Slog/components/Home";
// import WriteBlog from "../src/Slog/components/WriteBlog";
// import UserAccount from "../src/Slog/components/UserAccount";
// import PostDetails from "../src/Slog/components/PostDetails";
// import UpdateAccount from "../src/Slog/components/UpdateAccount";
// import DisplayUserProfile from "../src/Slog/components/DisplayUserProfile";

// news feed
import NewsFeedHome from "./Admin/News/RSS/NewsFeedHome";
import SavedFeeds from "../src/Admin/News/RSS/components/SavedFeeds";

// coach module
// import CoachAdminDashboard from "../src/CoachClient/components/AdminCoach_dashboard/AdminDashboard";
// import CoachArenaUserDashboard from "../src/CoachClient/components/coach_user_dashboard/Main_user_dash";
// import CoachArenaDashboard from "../src/CoachClient/components/coach-dashboard/arenaDashboard";
// import CoachRegisterArena from "../src/CoachClient/components/coach-reg/regarena";
// import CoachLoginArena from "../src/CoachClient/components/coach-reg/arenalogin";

// refree module
// import RefreeAdminDashboard from "./RefreeModule/AdminReferee_dashboard/AdminDashboard";
// import RefreeArenaUserDashboard from "./RefreeModule/referee_user_dashboard/Main_user_dash";
// import RefreeArenaDashboard from "./RefreeModule/referee-dashboard/arenaDashboard";
// import RefreeRegisterArena from "./RefreeModule/referee-reg/regarena";
// import RefreeLoginArena from "./RefreeModule/referee-reg/arenalogin";

// physician module
// import PhysicianAdminDashboard from "./PhysicianModule/src/components/AdminPhysician_dashboard/AdminDashboard";
// import PhysicianArenaUserDashboard from "./PhysicianModule/src/components/physician_user_dashboard/Main_user_dash";
// import PhysicianArenaDashboard from "./PhysicianModule/src/components/physician-dashboard/arenaDashboard";
// import PhysicianRegisterArena from "./PhysicianModule/src/components/physician-reg/regarena";
// import PhysicianLoginArena from "./PhysicianModule/src/components/physician-reg/arenalogin";

// dietitation module
// import DietitianAdminPanel from "./DietitianModule/AdminDietitian_dashboard/AdminDashboard";
// import DietitianArenaUserDashboard from "./DietitianModule/dietitian_user_dashboard/Main_user_dash";
// import DietitianArenaDashboard from "./DietitianModule/dietitian-dashboard/arenaDashboard";
// import DietitianRegisterArena from "./DietitianModule/dietitian-reg/regarena";
// import DietitianLoginArena from "./DietitianModule/dietitian-reg/arenalogin";

// advertisement module
import AdvertisementAdminPanel from "./Admin/Advertisement/AdminDashboard";

// Admin News Module
import { AdminNewsWrite } from "./Admin/News/AdminNewsWrite";
import { AdminPublishNews } from "./Admin/News/AdminPublishNews";
import { AdminNewsDisplay } from "./Admin/News/AdminNewsDisplay";

// News Components
import AllNews from "./dasboard-component/AllNews";
import NewsDetails from "./dasboard-component/NewsDetails";

// Add/View Module
import UserDashboardApp from "./UserDashboardModule/App";
import { Selection } from "./CreateGamesModule/Selection";
import { AddSnooker } from "./CreateGamesModule/AddSnooker";
import ViewGame from "./CreateGamesModule/ViewGame";
import { AddTennis } from "./CreateGamesModule/AddTennis";
import { AddTableTennis } from "./CreateGamesModule/AddTableTennis";

// Ecommerce Module
// import Store from "./ECommerce/components/store";
// import LoginPage from "./ECommerce/components/login";
// import SignupPage from "./ECommerce/components/signUp";
// import ManufacturerStoreDashboard from "./ECommerce/components/manufacturerStore";
// import RetailerStore from "./ECommerce/components/retailerStore";
// import Vendor from "./ECommerce/Admin/Vendor";
// import SuperAdmin from "./ECommerce/pages/SuperAdmin";
// import OrderTrackingTable from "./ECommerce/components/order-tracking";
// import OrderTrackingTable2 from "./ECommerce/components/order-track-manufacturer";
// import AddProduct from "./ECommerce/components/add-manufacture-product";
// import EcommerceAdminPanel from "./ECommerce/AdminEcommerce_dashboard/AdminDashboard";
// import ManufacturerProductDetail from "./ECommerce/components/ManufacturerProductDetail";
// import AddRetailerProduct from "./ECommerce/components/add-retail-product";
// import RetailerProductDetail from "./ECommerce/components/RetailerProductDetail";
// import RetailerManufacturerOrders from "./ECommerce/components/retailer-manufacturer-orders";
// import RetailerUserOrderDetail from "./ECommerce/components/retailer-user-order";
// import Catalog from "./ECommerce/components/retailer-manufacturer-catalog";
// import RetailerOrderDetail from "./ECommerce/components/RetailerOrderDetail";
// import RentalStore from "./ECommerce/components/rentalStore";
// import AddRentalProduct from "./ECommerce/components/add-rental-product";
// import UserOrders from "./ECommerce/components/user-orders";
// import OrderTrackingRental from "./ECommerce/components/order-tracking-rental";
// import RentalProductDetail from "./ECommerce/components/RentalProductDetail";
// import RentalUserOrderDetail from "./ECommerce/components/rental-user-order";
// import NearbyStores from "./ECommerce/components/nearby-stores";
// import BusinessProfile from "./ECommerce/components/BusinessProfile";
// import NearbyManufacturers from "./ECommerce/components/nearby-manu";
import SportsControl from "./Admin/General/SportsControl";
import AddFootball from "./CreateGamesModule/AddFootball";
import AddBasketball from "./CreateGamesModule/AddBasketball";
import AddPadelTennis from "./CreateGamesModule/AddPadelTennis";
import AddVolleyball from "./CreateGamesModule/AddVolleyball";
import { AddCricket } from "./CreateGamesModule/AddCricket";
import { AddHockey } from "./CreateGamesModule/AddHockey";
import { AddSwimming } from "./CreateGamesModule/AddSwimming";
import { AddSquash } from "./CreateGamesModule/AddSquash";
import { DsportSuperAdminDashboard } from "./Admin/DsportSuperAdminDashboard";
import { AddGolf } from "./CreateGamesModule/AddGolf";
import SportRequests from "./ArenaManagementSystem/arena_user_dashboard/SportRequests";
import { PlayerProfile } from "./dasboard-component/PlayerProfile";
import UserSearchResults from "./dasboard-component/UserSearchResults";
import PageNotFound from "./dasboard-component/PageNotFound";
import NoAccess from "./dasboard-component/NoAccess";
import ProtectedRoute from "./Authorization/ProtectedRoute";
import AuthenticatedRoute from "./Authorization/AuthenticatedRoute";
import { RegisterInstitute } from "./institutes";
import InstituteManagement from "./institutes/admin/InstituteManagement";
import InstituteDetails from "./institutes/admin/InstituteDetails";
import UserInstituteDetails from "./institutes/user/UserInstituteDetails";

function App() {
  return (
    <React.StrictMode>
      <AuthProvider>
        <ArenaAuthProvider>
          <ContributorAuthProvider>
            <InstituteAuthProvider>
              <BusinessAuthProvider>
                <Router>
                  <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                  <Routes>
                    {/* Landing Route - Marketing page for all users */}
                    <Route path="/" element={<AuthenticatedRoute />} />
                    <Route path="/login-arena" element={<LoginUser />} />
                    <Route
                      path="/reg-verification"
                      element={<VerificationPage />}
                    />
                    <Route path="/signupafter" element={<Signup />} />
                    <Route
                      path="/forgot-password"
                      element={<ForgotPassword />}
                    />
                    <Route
                      path="/forgot-password-arena"
                      element={<ForgotPasswordArena />}
                    />
                    <Route
                      path="/forgot-password-institute"
                      element={<ForgotPasswordInstitute />}
                    />

                    {/* User and Tester Routes - Regular users and testers can access based on permissions */}
                    <Route
                      path="/main-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="news"
                          userOnly={true}
                        >
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />

                    {/* Informatica Routes */}
                    <Route
                      path="/loginContributor"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <ContributorLogin />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/register"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <RegisterContributor />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/search"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <Search />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/search-results"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <SearchResults />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/article/:id"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <ViewArticle />
                        </ProtectedRoute>
                      }
                    />

                    <Route
                      path="/contributor-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <ContributorDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/edit-profile"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <EditContributorProfile />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/post-article"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <ArticlePost />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/edit-article/:id"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="informatica"
                        >
                          <EditArticle />
                        </ProtectedRoute>
                      }
                    />

                    {/* Player Profile Routes - Available to users and testers with player profiling access */}
                    <Route
                      path="/Manage"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <ManageUser />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/player-profile/:userId"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <PlayerProfile />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/user-search-results"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <UserSearchResults />
                        </ProtectedRoute>
                      }
                    />

                    {/* Arena Routes - Available to users and testers with arena access */}
                    <Route
                      path="/user-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <ArenaUserDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/arena-details/:arenaId"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <ArenaDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/register-arena/:context?"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <RegisterArena />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/Arena-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <ArenaDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/sport-requests"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <SportRequests />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/LoginArena"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <LoginArena />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/arena-ownership-transfer/:token"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <ArenaOwnershipTransfer />
                        </ProtectedRoute>
                      }
                    />

                    {/* Accounting Routes - Users only (testers should not have access to financial data) */}
                    <Route
                      path="/transaction-history"
                      element={
                        <ProtectedRoute userOnly={true}>
                          <TransactionHistory />
                        </ProtectedRoute>
                      }
                    />
                    {/* mobile screen design not done */}
                    <Route
                      path="/assets-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="arena"
                          userOnly={true}
                        >
                          <AssetDashboard />
                        </ProtectedRoute>
                      }
                    />

                    {/* News Routes - Available to users and testers with news access */}
                    <Route
                      path="/all-news"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="news"
                          userOnly={true}
                        >
                          <AllNews />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/display-user-news/:id"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="news"
                          userOnly={true}
                        >
                          <NewsDetails />
                        </ProtectedRoute>
                      }
                    />

                    {/* Add/View Games Routes - Available to users and testers with player profiling access */}
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <UserDashboardApp />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-game"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <Selection />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-snooker"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddSnooker />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-tennis"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddTennis />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-table-tennis"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddTableTennis />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-golf"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddGolf />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-football"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddFootball />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-basketball"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddBasketball />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-padel-tennis"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddPadelTennis />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-volleyball"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddVolleyball />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-cricket"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddCricket />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-hockey"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddHockey />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-swimming"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddSwimming />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/add-squash"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <AddSquash />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/view-game"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="player_profiling"
                          userOnly={true}
                        >
                          <ViewGame />
                        </ProtectedRoute>
                      }
                    />

                    {/* Institute Routes */}
                    <Route
                      path="/register-institute"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <RegisterInstitute />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-login"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteLogin />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-dashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institutes/:id"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <UserInstituteDetails />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-owner"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteOwnerDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-add-game"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteGameSelection />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-view-game"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteViewGame />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-profile"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="institute"
                          userOnly={true}
                        >
                          <InstituteProfileManagement />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/user-affiliations"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["user", "tester"]}
                          requiredAccessRight="user_affiliations"
                          userOnly={true}
                        >
                          <UserAffiliationsDashboard />
                        </ProtectedRoute>
                      }
                    />

                    {/* slog implementation */}
                    {/* <Route path="/Home" element={<Home />} /> */}
                    {/* <Route path="/write-blog" element={<WriteBlog />} /> */}
                    {/* <Route path="/write-blog/:id" element={<WriteBlog />} /> */}
                    {/* <Route path="/user-account" element={<UserAccount />} /> */}
                    {/* <Route
                      path="/display-blog/:postId"
                      element={<PostDetails />}
                    /> */}
                    {/* <Route path="/update-account" element={<UpdateAccount />} /> */}
                    {/* <Route
                      path="/user-profile/:userId"
                      element={<DisplayUserProfile />}
                    /> */}

                    {/* Coach Routes */}
                    {/* <Route
                      path="/coach-user"
                      element={<CoachArenaUserDashboard />}
                    /> */}
                    {/* <Route
                      path="/coach-dashboard"
                      element={<CoachArenaDashboard />}
                    /> */}
                    {/* <Route
                      path="/coach-registration"
                      element={<CoachRegisterArena />}
                    /> */}
                    {/* <Route path="/coach-login" element={<CoachLoginArena />} /> */}

                    {/* Refree Routes */}
                    {/* <Route
                      path="/referee-user"
                      element={<RefreeArenaUserDashboard />}
                    /> */}
                    {/* <Route
                      path="/referee-dashboard"
                      element={<RefreeArenaDashboard />}
                    /> */}
                    {/* <Route
                      path="/referee-registration"
                      element={<RefreeRegisterArena />}
                    /> */}
                    {/* <Route
                      path="/referee-login"
                      element={<RefreeLoginArena />}
                    /> */}

                    {/* Physician Routes */}
                    {/* <Route
                      path="/physician-user"
                      element={<PhysicianArenaUserDashboard />}
                    /> */}
                    {/* <Route
                      path="/physician-dashboard"
                      element={<PhysicianArenaDashboard />}
                    /> */}
                    {/* <Route
                      path="/physician-registration"
                      element={<PhysicianRegisterArena />}
                    /> */}
                    {/* <Route
                      path="/physician-login"
                      element={<PhysicianLoginArena />}
                    /> */}

                    {/* Dietitian Routes */}
                    {/* <Route
                      path="/dietitian-user"
                      element={<DietitianArenaUserDashboard />}
                    /> */}
                    {/* <Route
                      path="/dietitian-dashboard"
                      element={<DietitianArenaDashboard />}
                    /> */}
                    {/* <Route
                      path="/dietitian-registration"
                      element={<DietitianRegisterArena />}
                    /> */}
                    {/* <Route
                      path="/dietitian-login"
                      element={<DietitianLoginArena />}
                    /> */}

                    {/* Ecommerce Routes */}
                    {/* <Route path="/VendorAdmin" element={<Vendor />} /> */}

                    {/* ---------------- */}

                    {/* <Route path="/ecommerce" element={<Store />} /> */}
                    {/* <Route
                      path="/ecommerce-nearby-stores"
                      element={<NearbyStores />}
                    /> */}
                    {/* <Route
                      path="/ecommerce-vendor/:id"
                      element={<BusinessProfile />}
                    /> */}
                    {/* <Route
                      path="/ecommerce-user-orders"
                      element={<UserOrders />}
                    /> */}
                    {/* <Route path="/ecommerce-login" element={<LoginPage />} /> */}
                    {/* <Route path="/ecommerce-signup" element={<SignupPage />} /> */}

                    {/* ---------------- */}

                    {/* <Route
                      path="/manufacturerStore"
                      element={<ManufacturerStoreDashboard />}
                    /> */}
                    {/* <Route
                      path="/add-manufacture-product"
                      element={<AddProduct />}
                    /> */}
                    {/* <Route
                      path="/manufacturer-product/:productId"
                      element={<ManufacturerProductDetail />}
                    /> */}
                    {/* <Route
                      path="/manufacturer-order/:orderId"
                      element={<OrderTrackingTable2 />}
                    /> */}

                    {/* ---------------- */}

                    {/* <Route path="/retailerStore" element={<RetailerStore />} /> */}
                    {/* <Route
                      path="/nearby-manufacturers"
                      element={<NearbyManufacturers />}
                    /> */}
                    {/* <Route
                      path="/add-retailer-product"
                      element={<AddRetailerProduct />}
                    /> */}
                    {/* <Route
                      path="/retailer-product/:productId"
                      element={<RetailerProductDetail />}
                    /> */}
                    {/* <Route
                      path="/order-tracking-retailer"
                      element={<OrderTrackingTable />}
                    /> */}
                    {/* <Route
                      path="/retailer-manufacturer-orders"
                      element={<RetailerManufacturerOrders />}
                    /> */}
                    {/* <Route
                      path="/retailer-manufacturer-order/:orderId"
                      element={<RetailerOrderDetail />}
                    /> */}
                    {/* <Route
                      path="/retailer-user-order/:orderId"
                      element={<RetailerUserOrderDetail />}
                    /> */}
                    {/* <Route
                      path="/retailer-manufacturer-catalog"
                      element={<Catalog />}
                    /> */}

                    {/* ---------------- */}
                    {/* <Route path="/rentalStore" element={<RentalStore />} /> */}
                    {/* <Route
                      path="/add-rental-product"
                      element={<AddRentalProduct />}
                    /> */}
                    {/* <Route
                      path="/order-tracking-rental"
                      element={<OrderTrackingRental />}
                    /> */}
                    {/* <Route
                      path="/rental-product/:productId"
                      element={<RentalProductDetail />}
                    /> */}
                    {/* <Route
                      path="/rental-user-order/:orderId"
                      element={<RentalUserOrderDetail />}
                    /> */}

                    {/* SuperAdmin Only Routes */}
                    <Route
                      path="/DsportSuperAdmin"
                      element={
                        <ProtectedRoute superAdminOnly={true}>
                          <DsportSuperAdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/sports-control"
                      element={
                        <ProtectedRoute superAdminOnly={true}>
                          <SportsControl />
                        </ProtectedRoute>
                      }
                    />
                    {/* Admin Dashboard Route (Super Admin + Admin with access) */}
                    <Route
                      path="/DsportAdmin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                        >
                          <DsportAdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/AdminDashboard"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="arena"
                        >
                          <ArenaAdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    {/* <Route
                      path="/coach-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="coach"
                        >
                          <CoachAdminDashboard />
                        </ProtectedRoute>
                      }
                    /> */}
                    <Route
                      path="/institute-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="institute"
                        >
                          <InstituteManagement />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/institute-admin/details/:id"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="institute"
                        >
                          <InstituteDetails />
                        </ProtectedRoute>
                      }
                    />
                    {/* <Route
                      path="/referee-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="refree"
                        >
                          <RefreeAdminDashboard />
                        </ProtectedRoute>
                      }
                    /> */}
                    {/* <Route
                      path="/physician-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="physician"
                        >
                          <PhysicianAdminDashboard />
                        </ProtectedRoute>
                      }
                    /> */}
                    {/* <Route
                      path="/dietitian-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="dietition"
                        >
                          <DietitianAdminPanel />
                        </ProtectedRoute>
                      }
                    /> */}
                    <Route
                      path="/advertisement-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="advertisement"
                        >
                          <AdvertisementAdminPanel />
                        </ProtectedRoute>
                      }
                    />
                    {/* <Route
                      path="/ecommerce-admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="ecommerce"
                        >
                          <EcommerceAdminPanel />
                        </ProtectedRoute>
                      }
                    /> */}
                    {/* <Route
                      path="/ecommerce-SuperAdmin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="ecommerce"
                        >
                          <SuperAdmin />
                        </ProtectedRoute>
                      }
                    /> */}
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="informatica"
                        >
                          <AdminPanel />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/article-application"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="informatica"
                        >
                          <ArticleAdminPanel />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/News-Home"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="rss_news"
                        >
                          <NewsFeedHome />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/saved-feeds"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="rss_news"
                        >
                          <SavedFeeds />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/news-writing"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="news_writing"
                        >
                          <AdminNewsWrite />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/news-publishing"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="news_publishing"
                        >
                          <AdminPublishNews />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/display-admin-news/:newId"
                      element={
                        <ProtectedRoute
                          allowedUserTypes={["admin", "superadmin"]}
                          requiredAccessRight="news_publishing"
                        >
                          <AdminNewsDisplay />
                        </ProtectedRoute>
                      }
                    />

                    {/* End Routes */}
                    <Route path="/404" element={<PageNotFound />} />
                    <Route path="/no-access" element={<NoAccess />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </Router>
              </BusinessAuthProvider>
            </InstituteAuthProvider>
          </ContributorAuthProvider>
        </ArenaAuthProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}

export default App;
